import {styled} from '@mui/material/styles';
import {ReactNode} from 'react';
import {excludeComponentProps} from '../utils/excludeComponentProps';

interface ContentContainerProps {
    isContained?: boolean;
    children?: ReactNode;
    hasSideNav?: boolean;
}

export const ContentContainer = styled('div', {
    ...excludeComponentProps('isContained', 'hasSideNav')
})<ContentContainerProps>(({
    theme,
    hasSideNav,
    isContained
}) => ({
    display: 'grid',
    gridArea: 'content-container',
    gridTemplateAreas: `"page-title-action-area-container page-title-action-area-container" "${hasSideNav ? 'side-nav' : 'content'} content"`,
    gridTemplateColumns: 'auto 1fr',
    gridTemplateRows: 'auto 1fr',
    columnGap: '1rem',

    alignItems: 'start',

    width: '100%',
    padding: '1.5rem 1rem',

    ...isContained && {
        maxWidth: theme.breakpoints.values.lg,
        margin: '0 auto'
    }
}));
